export default "__VITE_ASSET__BXlk_eDl__"